<dt-table-layout *dtDataLoad="displayedProjects != null; error: hasError">
  <div header class="cp-filters-form">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Nach Name filtern</mat-label>
      <input matInput type="text" [(ngModel)]="nameFilter" (input)="updateDisplayedProjectsAndTagProductivity()" />
    </mat-form-field>

    <dt-tag-input
      [allTags]="tags"
      [(selectedTagIds)]="tagIdFilter"
      (selectedTagIdsChange)="updateDisplayedProjectsAndTagProductivity()"
      i18n
      >Nach Tags filtern</dt-tag-input
    >

    <div class="filler"></div>
    <button mat-raised-button color="primary" (click)="addProject()"
      ><mat-icon>add</mat-icon><ng-container i18n>Projekt hinzufügen</ng-container></button
    >
  </div>

  <table
    mat-table
    [dataSource]="displayedProjects"
    matSort
    [matSortDisableClear]="true"
    matSortActive="name"
    matSortDirection="asc"
    (matSortChange)="onSortChange($event)"
    [dtOverlayProgress]="atLeastOneActionPending$ | async"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <ng-container matColumnDef="visibility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Sichtbarkeit</th>
      <td class="visibility-cell" mat-cell *matCellDef="let row">
        <button
          [matTooltip]="row.visible ? 'Das Projekt ist für die Nutzer sichtbar' : 'Das Projekt ist für die Nutzer nicht sichtbar.'"
          i18n-matTooltip
          matTooltipPosition="right"
          matTooltipShowDelay="500"
          mat-icon-button
          (click)="$event.preventDefault(); toggleVisibility(row)"
          ><mat-icon [class.not-visible]="!row.visible">{{ row.visible ? 'visibility' : 'visibility_off' }}</mat-icon></button
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef i18n>Tags</th>
      <td mat-cell *matCellDef="let row">
        <dt-tag-list
          [tagIds]="row.tags"
          [tagsById]="tagsById"
          [selectedTagIds]="tagIdFilter"
          (tagClick)="tagClick($event.id)"
        ></dt-tag-list>
      </td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Aktualisiert am</th>
      <td mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef i18n>Aktionen</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="$event.preventDefault(); edit(row)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button [cdkCopyToClipboard]="row.shareUrl" (click)="$event.preventDefault()">
          <mat-icon>share</mat-icon>
        </button>
        <button mat-icon-button (click)="$event.preventDefault(); downloadClick($event, row)">
          <mat-icon>download</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="$event.defaultPrevented || showDetails(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Projekte entsprechen dem Filter.</td>
    </tr>
  </table>

  <dt-table-footer [visibleCount]="displayedProjects.length" [totalCount]="projects.length"></dt-table-footer>
</dt-table-layout>
